import React from 'react';
import styled from 'styled-components';
import {Form} from 'components/antd';
import {useFormik} from 'formik';
import useSearchParams from '../../useSearchParams';
import {InputNumber} from 'components';

const OfficesNumberFilter = () => {
  const {query, setQuery} = useSearchParams();

  const {officesNumber = {from: null, to: null}} = query;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      officesNumber,
    },
    onSubmit: (values) => {
      setQuery(values);
    },
  });

  return (
    <Container>
      <Form.Item>
        <StyledInputNumber
          min={1}
          max={10000}
          value={formik.values.officesNumber?.from}
          onChange={(value) =>
            formik.setFieldValue('officesNumber.from', value)
          }
          onBlur={() => formik.handleSubmit()}
        />
        <span> 〜 </span>
        <StyledInputNumber
          min={1}
          max={10000}
          value={formik.values.officesNumber?.to}
          onChange={(value) => formik.setFieldValue('officesNumber.to', value)}
          onBlur={() => formik.handleSubmit()}
        />
      </Form.Item>
    </Container>
  );
};

const Container = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;

const StyledInputNumber = styled(InputNumber)`
  border: 1px solid rgb(217, 217, 217) !important;
  width: 175px;
`;

export default OfficesNumberFilter;
